import { GesturePlugin } from '@vueuse/gesture'

export default defineNuxtPlugin({
  name: 'vueuse',
  async setup(nuxtApp) {
    nuxtApp.vueApp.use(GesturePlugin)
  },
})
